const config = require('../config'); const apiConfig = require('../api-config');
const keyBy = require('lodash/keyBy');
const find = require('lodash/find');
const pathResult = require('../resources/path-result');
const apiFactory = require('../resources/vascoauthentication/api-factory');
const serviceFactory = require('../resources/vascoauthentication/service-factory');
const parseRequestMetaData = require('../utils/parse-request-meta-data');


function parseJson(obj) {
  return JSON.stringify(obj);
}


function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/globalauth/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match((
      `${p}vascoauthentication.generateActPwdAndRegId[{keys:deviceCode}][{keys:isNTB}][{keys:authCode}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getActPwdAndRegId(req.params.deviceCode, req.params.isNTB == 'true', req.params.authCode, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.generateServerEphPubKey[{keys:deviceCode}][{keys:clientEphimeralPubKey}][{keys:registrationID}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.generateServerEphPubKey(req.params.clientEphimeralPubKey, req.params.registrationID, req.params.deviceCode, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.generateServerEvidenceMessage[{keys:deviceCode}][{keys:clientEvidenceMessage}][{keys:registrationID}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.generateServerEvidenceMessage(req.params.clientEvidenceMessage, req.params.registrationID, req.params.deviceCode, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.activateDevice[{keys:deviceCode}][{keys:deviceCodeTwoFactorValue}][{keys:registrationID}][{keys:isReinstallationFlag}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.activateDevice(req.params.deviceCode, req.params.deviceCodeTwoFactorValue.substring(1, req.params.deviceCodeTwoFactorValue.length), req.params.registrationID, req.params.isReinstallationFlag, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.verifyDeviceSignature[{keys:deviceCode}][{keys:isNTB}][{keys:signature}][{keys:registrationID}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.verifyDeviceSignature(req.params.deviceCode, req.params.isNTB, req.params.signature.substring(1, req.params.signature.length), req.params.registrationID, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.verifyOTP[{keys:ran_str}][{keys:deviceCode}][{keys:oneTimePassword}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.verifyOTP(req.params.deviceCode, req.params.oneTimePassword.substring(1, req.params.oneTimePassword.length), req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.handleSecondFactorStatus[{keys:deviceCode}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.handleSecondFactorStatus(req.params.deviceCode, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.getSecondFactorAuthServerTime`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getSecondFactorAuthServerTime(req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.setUserLoginAlias`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.setUserLoginAlias(req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.updateActivationStatus[{keys:deviceCode}][{keys:isNTB}][{keys:vascoStatus}][{keys:isRegistrationSkipped}][{keys:emailId}][{keys:language}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.updateActivationStatus(req.params.deviceCode, req.params.isNTB, req.params.vascoStatus, req.params.isRegistrationSkipped, req.params.emailId, req.params.language, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.deactivateSecondFactor[{keys:deviceCode}][{keys:forgetPinMessage}][{keys:serialInstance}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.deactivateSecondFactor(req.params.deviceCode, req.params.forgetPinMessage, req.params.serialInstance, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.auditSecondfactorEventLog[{keys:deviceCode}][{keys:logMessage}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.auditSecondfactorEventLog(req.params.deviceCode, req.params.logMessage, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

    .match((
      `${p}vascoauthentication.registerViaSMS[{keys:guidStr}][{keys:inputs}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.registerViaSMS(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))


    .match((
      `${p}vascoauthentication.validateSMSAuthCode[{keys:guidStr}][{keys:inputs}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.validateSMSAuthCode(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.handleSecondFactorStatusAndAuthServerTime[{keys:deviceCode}][{keys:serverTimeValue}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.handleSecondFactorStatusAndAuthServerTime(req.params.deviceCode, req.params.serverTimeValue, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.fetchSecondFactorStatusDetails[{keys:guidStr}][{keys:inputs}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.fetchSecondFactorStatusDetails(req.params.inputs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}vascoauthentication.deactivateDevice[{keys:deviceCode}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.deactivateDevice(req.params.deviceCode, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )));
  ;

}

module.exports = addRoutes;
